//ServiceTypes
export const deliveryTypes = [
    {
        value: 'WarehouseWarehouse',
        label: 'На отделение',
    },
    {
        value: 'WarehouseDoors',
        label: 'Адресная доставка',
    }
];

//TypesOfPayers, TypesOfPayersForRedelivery
export const deliveryPayers = [
    {
        value: 'Sender',
        label: 'Отправитель',
    },
    {
        value: 'Recipient',
        label: 'Получатель',
    },
    {
        value: 'ThirdPerson',
        label: 'Третье лицо',
    }
];

//PaymentForm
export const paymentForm = [
    {
        value: 'NonCash',
        label: 'Безналичная',
    },
    {
        value: 'Cash',
        label: 'Наличная',
    }
];

//CargoTypes
export const cargoType = [
    {
        value: 'Parcel',
        label: 'Посылка',
    },
    {
        value: 'Cargo',
        label: 'Груз',
    },
    {
        value: 'Documents',
        label: 'Документы',
    },
    {
        value: 'TiresWheels',
        label: 'Шины-Диски',
    },
    {
        value: 'Pallet',
        label: 'Паллета',
    }
];

//BackwardDeliveryCargoTypes
export const backwardCargoType = [
    {
        value: 'Documents',
        label: 'Документы',
    },
    {
        value: 'Money',
        label: 'Денежный перевод',
    },
    {
        value: 'Other',
        label: 'Другие',
    },
];

//BackwardDeliveryPaymentType - custom
export const backwardPaymentType = [
    {
        value: 'Cash',
        label: 'Наличкой на отделение',
    },
    {
        value: 'AfterpaymentOnGoodsCost',
        label: 'Контроль оплаты',
    },
];
